import MuiTab from '@material-ui/core/Tab';
import { withStyles } from '@material-ui/core/styles';

import styles from './styles';

const Tab = withStyles(styles)(MuiTab);

export default Tab;
